import React, {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
} from "react";
import { useNavigate } from "react-router-dom";


import arrow from "../../../Images/Group 1171279362.png";
import HomeService from "../../../Services/HomeService";

import "./WinnerBlueLan.css";


const WinnersHomeCitiesBlue = ({ allowedCities, title }) => {
  const [loginProfile, setLoginProfile] = useState(null);
  const [cities, setCities] = useState([]);
  const [userId, setUserId] = useState(null);

  const sectionRef = useRef(null);
  const navigate = useNavigate();

  const handleCityFilter = async (userID, city) => {
    if (title === "Working in cities") {
      if (!loginProfile) {
        navigate("/profile");
        return;
      }

      navigate("/propertyList", {
        state: {
          cityId: city?._id,
          loggedInUserId: userID,
        },
      });
    }
  };

  const getAllCity = async () => {
    try {
      const res = await HomeService.getAllCities();

      if (res) {
        setCities(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCity();
  }, []);

  useEffect(() => {
    const getLoginProfile = async () => {
      try {
        const res = await HomeService.getLoginProfile();

        if (res?.status) {
          setLoginProfile(res?.data);
          setUserId(res?.data?._id);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getLoginProfile();
  }, []);





  return (
    <section
      className="ws-cities-section_blue"
      ref={sectionRef}
    >
      <div className="floating-blob_blue blob1_blue"></div>
      <div className="floating-blob_blue blob2_blue"></div>

      <div className="ws-cities-container_blue">
        <div className="ws-cities-header_blue">
          <span className="ws-cities-tag_blue">
            Premium Locations
          </span>

          <h2 className="ws-cities-title_blue">
            {title}
          </h2>

          <p className="ws-cities-subtitle_blue">
            Explore top-performing markets and discover
            premium opportunities across India's fastest
            growing cities.
          </p>
        </div>

        <div className="wcity-grid_blue">
          {cities
            ?.filter((city) => allowedCities?.includes(city.name))
            .map((city, index) => (
              <div
                key={city?._id || index}
                className="wcity-card_blue"
                onClick={() => handleCityFilter(userId, city)}
                style={{
                  cursor:
                    title === "Working in cities"
                      ? "pointer"
                      : "default",
                }}
              >
                <div className="wcity-image-wrap_blue">
                  <img
                    src={city.image}
                    alt={city.name}
                    className="wcity-image_blue"
                  />

                  <div className="wcity-overlay_blue"></div>

                  <div className="wcity-content_blue">
                    <span className="wcity-badge_blue">
                      Premium Market
                    </span>

                    <h3>{city.name}</h3>

                    <p>
                      Explore premium opportunities and
                      verified properties.
                    </p>

                    {city?.isSubscribedByUser && (
                      <button className="wcity-btn_blue">
                        Explore
                        <img
                          src={arrow}
                          alt=""
                          width={16}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default WinnersHomeCitiesBlue;